import type { FlattenSimpleInterpolation } from 'styled-components'
import styled, { css } from 'styled-components'

import { advancedSpacing } from '@vfuk/core-mixins'

import type { StyledInLineNotificationProps } from './InLineNotification.style.types'

export const InLineNotification = styled.div<StyledInLineNotificationProps>(
  (props: StyledInLineNotificationProps): FlattenSimpleInterpolation => {
    const localThemeAppearance = props.inlineNotificationTheme.appearance[props.appearance]
    return css`
      display: flex;
      align-items: center;
      background-color: ${localThemeAppearance.backgroundColor};
      ${advancedSpacing('padding', [1, 2, 1, 0])};
    `
  },
)

export const IconWrapper = styled.div(
  (): FlattenSimpleInterpolation => css`
    display: flex;
    align-items: center;
    ${advancedSpacing('padding', [0, 2])};
  `,
)
